export function makeLazyReady(html: string, nativeLazyLoad = false): string {
  return html.replace(/<img([\w\W]+?)>/g, (_, attributes) => {
    if (nativeLazyLoad) {
      return `<img loading="lazy"${attributes}>`
    } else {
      return `<img${attributes.replace(/src="(.*?)"/, 'data-src="$1"')}>`
    }
  })
}
